import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Container } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../../app/layout/PageHeader";
import { useStore } from "../../../app/stores/store";
import ImportDisclaimers from "./ImportDisclaimers";
import ImportFileSelection from "./ImportFileSelection";

export default observer(function Import() {
  const { t } = useTranslation(["common", "advancedSettings"]);

  const { userStore } = useStore();
  const { user } = userStore;

  const [ confirmed, setConfirmed ] = useState<boolean>(false);

  return (
    <>
      <PageHeader
        header={t("import.header", { ns: "advancedSettings" })}
        type={"h2"}
        divider={true}
        getAlerts={true}
        showHelp
        helpName="settings.advanceSettings.dataImport"
        addTitle={true}
      />

      {!user?.importEnabled ? (
      <Container className="page">
        <p>{t("import.p1", { ns: "advancedSettings" })}</p>
        <p>{t("import.p2", { ns: "advancedSettings" })}</p>
        <p data-testid="content">{t("import.p3", { ns: "advancedSettings" })}</p>
      </Container>
      ) : (
        <>
          {!confirmed ? <ImportDisclaimers setConfirmed={setConfirmed} /> : <ImportFileSelection />}
        </>
      )}
    </>
  );
});
